import styled, { css } from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

/**
 * @deprecated use @r1-frontend/ui-react/alert
 */
export const ResultMessage = styled.div<{isResultNoFreeTime?: boolean, isError?: boolean}>`
    flex-wrap: nowrap;
    align-items: flex-start;
    margin-bottom: ${({ isResultNoFreeTime }) => isResultNoFreeTime ? '0' : '20px'};
    width: 100%;
    ${FONTS.S};
    ${({ isError }) => isError && css`
        padding: 18px;
        background-color: ${COLORS.BgError};
        border-radius: ${BorderRadius.OuterBlockRadius};
    `};
  
`;

/**
 * @deprecated use @r1-frontend/ui-react/alert
 */
export const IconWrap = styled.div`
    justify-content: center;
    align-items: center;
`;

/**
 * @deprecated use @r1-frontend/ui-react/alert
 */
export const Icon = styled.img`
    width: 20px;
    height: 20px;
    margin-right: 10px;
`;
